import { Component, Input, Output, EventEmitter, OnInit, Injectable } from '@angular/core';

@Component({
  selector: 'star',
  templateUrl: './star.component.html',
  styleUrls: ['./star.component.css']
})
@Injectable()
export class StarComponent implements OnInit {
  @Input() totalStars = [];//<---this is better
  @Input() starLiked:string = "none";
  starsLiked = [];
  voterStars:number;
  voters:number;
  userVote:number = 0;
  userStars:number;
  calculatedStarsTotals;
  starsOtherUsersLiked = [];

  @Output() change = new EventEmitter();


  constructor() { }

  ngOnInit() {
    console.log("ngOnInit");
    //console.log("this.starLiked",this.starLiked);
    //this.countStars("ngOnInit",this.starLiked);

    var starCountObject = window['getTotalStars']();
    this.voterStars = starCountObject.totalStars;
    this.voters = starCountObject.totalVoters;
    this.userVote = starCountObject.userVote;
    this.userStars = starCountObject.userStars;
    //this.starsLikedOtherVoters = this.totalStars;

    
    // this.calculatedStarsTotals = (this.voterStars+this.userStars)/(this.voters+this.userVote);
    // the ".0" .toFixed(1) is added in star.component.html 
    if(this.userVote>0){
        console.log("Display this user's previous star count.");
        
        this.countStars("ngOnInit",this.totalStars[this.userStars-1]);
    }else{
        // If default is wrong, make sure that user stars don't get counted, if the user hasn't voted yet. 
        console.log("This user has not voted yet.");
        this.userStars = 0;
        // calculate totalStars from all voters. (otherwise value will display NaN)
        this.calculatedStarsTotals = Math.floor(100*(this.voterStars)/(this.voters))/100;
        if(isNaN(this.calculatedStarsTotals)){
            this.calculatedStarsTotals = 0;
        }
        this.calculateOtherUserStars();
        
    }

    
    
    
}

  onClick($event,starID){
        console.log("onClick");
        console.log("starID",starID);
        this.countStars($event,starID);
 }

 onMouseOver($event,starID){
        console.log("onMouseOver");
        console.log("starID",starID);
        this.countStars($event,starID);

        var starCountObject = {
            userVote: this.userVote,
            userStars: this.userStars
        };

        window['updateTotalStars']({
            userVote: 1,
            userStars: this.userStars
        });
 }

  countStars($event,starID){
      console.log("countStars $event",$event);
      
      
      this.starLiked = starID;
      this.starsLiked = [];
      for (var a=0; a < this.totalStars.length; a++){
          this.starsLiked.push(false);
      }
      this.starsLiked = this.getStarCount(this.starLiked);
      console.log("totalStars["+this.totalStars.indexOf(starID) +"] == "+ this.starLiked);
      this.change.emit({newValue: this.starLiked});
      //console.log(this.starsLiked);

      var starCount:number = 0;
      for (var i=0; i < this.starsLiked.length; i++){
          if(this.starsLiked[i]){
              starCount += 1;
          }
      }
      this.userVote = 1;
      this.userStars = starCount;

      this.calculatedStarsTotals = Math.floor(100*(this.voterStars+this.userStars)/(this.voters+this.userVote))/100;
      if(isNaN(this.calculatedStarsTotals)){
            this.calculatedStarsTotals = 0;
        }
      this.calculateOtherUserStars();
  }


  calculateOtherUserStars(){
      var countOfAllUserStar = Math.floor(this.calculatedStarsTotals);
      //console.log("countOfAllUserStar", countOfAllUserStar);
      this.starsOtherUsersLiked = [];
      for (var i=0; i < countOfAllUserStar; i++){
        this.starsOtherUsersLiked.push(true);
      }
      console.log("starsOtherUsersLiked ",this.starsOtherUsersLiked.length);
      // the ".0" .toFixed(1) is added in star.component.html 
  }

  getStarCount(starID){
      var hasMatchingStar = false;
      var tempStarsLiked = [];
      for (var a=0; a < this.totalStars.length; a++){
          tempStarsLiked.push(false);
      }
      for (var i=0; i < this.totalStars.length; i++){
          
          tempStarsLiked[i] = true;

          var thisStar = this.totalStars[i];
          //console.log(thisStar);
          if(thisStar == starID){
              hasMatchingStar = true;
              this.starsLiked = tempStarsLiked;
              break;
          }
      }
      //console.log(this.starsLiked);
      //console.log(this.starsLiked[this.totalStars.indexOf(starID)])

      return this.starsLiked;
  }

}



// WEBPACK FOOTER //
// /Users/aubreyfletcher/Desktop/projects/node/node_projects/ng5/cashfletcher_videoPlayer/src/app/star/star.component.ts